export const exerciseOptions = {
    method: 'GET',
    headers: {
      'X-RapidAPI-Key': 'f4e3c6f8bamsh19ac85582ef393dp16e635jsn36f096b38bb4',
      'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com'
    }
  };
export const youtubeOptions = {
    method: 'GET',
    headers: {
      'X-RapidAPI-Key': 'e0674313f2mshcce8e54eb864655p16acc8jsn3b1a7741e395',
      'X-RapidAPI-Host': 'youtube-search-and-download.p.rapidapi.com'
    }
};
export const fetchData=async(url,options)=>{
    const response = await fetch(url,options);
    const data = await response.json();
    return data;
}
